import { QueryApiOptions } from '../../types/types';
import createClient from 'openapi-fetch';
import {
  EnrichedProductParams,
  ProductFeaturesComparisonPathVariables,
  ProductServicePaths,
  AemConfiguration,
} from '@as-react/common-types';

import { AxiosRequestConfig } from 'axios';
import { axiosClient } from '@as-react/common-utils';
import { createUrl, getEndpoint } from '../../utils/createUrl';

export type ProductInformationParams = {
  productCode: string;
  colorId?: number;
};

export type ProductComparisonFeaturesParams = {
  fictiveWebShop: AemConfiguration['fictiveWebShop'];
  productId: number;
};

const urlMapping = {
  information: {
    client: '/api/aem/product/productcode',
    server: '/enrichedproduct/productcode',
  },
  comparisonFeatures: {
    client: '/api/aem/product/features/comparison/{market}/{mainWebShopId}/{productId}',
    // server: '/cache/product/features/comparison/{market}/{mainWebShopId}/{productId}',
  },
  notifyMeSubscribe: {
    client: 'api/notifyme/request',
  },
} as const;

const client = createClient<ProductServicePaths>();

export const getInformation = async (
  { servicesEndpoint, defaultRequestParams, isServer }: QueryApiOptions,
  { productCode, colorId }: EnrichedProductParams
) => {
  const { data, error } = await client.GET(getEndpoint(urlMapping.information, isServer), {
    baseUrl: servicesEndpoint,
    params: {
      // @ts-expect-error incorrect type for mainWebShop
      query: {
        ...defaultRequestParams,
        productCode,
        colorId,
      },
    },
  });

  if (error) {
    throw new Error(error);
  }

  return data;
};

export const getComparisonFeatures = async (
  { servicesEndpoint, defaultRequestParams }: QueryApiOptions,
  { productId, mainWebShopId }: ProductFeaturesComparisonPathVariables
) => {
  const { market, language } = defaultRequestParams;
  const { data, error } = await client.GET(urlMapping.comparisonFeatures.client, {
    baseUrl: servicesEndpoint,
    params: {
      path: { market, mainWebShopId, productId },
      query: { language },
    },
  });

  if (error) {
    throw new Error(error);
  }

  return data;
};

export type NotifyMeSubscribeParams = {
  productId: number;
  skuId: number;
  email: string;
};

export const postNotifyMeSubscribe = async (
  { servicesEndpoint, isServer, defaultRequestParams }: QueryApiOptions,
  { productId, skuId, email }: NotifyMeSubscribeParams
): Promise<void> => {
  const { mainWebshop, shopId, language } = defaultRequestParams;
  const url = createUrl(servicesEndpoint, urlMapping.notifyMeSubscribe, isServer);

  const axiosConfig: AxiosRequestConfig = {
    method: 'POST',
    url,
    params: { mainWebshop, shopId, language },
    data: { productId, skuId, email },
    withCredentials: true,
  };

  const result = await axiosClient.request(axiosConfig);
  return result.data;
};
